export default __webpack_public_path__ + "_/images/logo-egb-77ed156c6885fc306f704414ec025d44f330204fbffe82a8daf8718b65266f02.svg";